import GeneralFilter from '../../../../Model/GeneralFilter'

export default class OwnerFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
